export const COMMERCIAL_DOC_TYPE_ESTIMATE = 'devis'
export const COMMERCIAL_DOC_TYPE_INVOICE = 'facture'

/**
 * Informations sur le type de facture
 */
export const COMMERCIAL_DOC_TYPE_INVOICE_INVOICE = false
export const COMMERCIAL_DOC_TYPE_INVOICE_AVOIR = true
export const COMMERCIAL_DOC_TYPE_INVOICE_TYPES = [
  { value: COMMERCIAL_DOC_TYPE_INVOICE_INVOICE, label: 'Facture', icon: 'fa fa-file-invoice-dollar' },
  { value: COMMERCIAL_DOC_TYPE_INVOICE_AVOIR, label: 'Avoir', icon: 'fa fa-hand-holding-usd' }
]

/** Clé descriptive du client d'un document */
export const COMMERCIAL_DOC_TYPE_CUSTOMER_EMAIL_KEY = 'customerEmail'
export const COMMERCIAL_DOC_TYPE_CUSTOMER_SLUG_KEY = 'customerSlug'

/** Clé descriptive du destinataire du devis */
export const COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_KEY = 'estimateCustomer'
export const COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_EMAIL_KEY = 'estimateCustomerEmail'
/** Clé descriptive du destinataire de la facture */
export const COMMERCIAL_DOC_TYPE_INVOICE_CUSTOMER_KEY = 'invoiceCustomer'

export const COMMERCIAL_DOC__CUSTOMER_KEY_BY_TYPE = {
  [COMMERCIAL_DOC_TYPE_ESTIMATE]: COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_KEY,
  [COMMERCIAL_DOC_TYPE_INVOICE]: COMMERCIAL_DOC_TYPE_INVOICE_CUSTOMER_KEY
}

export const COMMERCIAL_DOCS_VERSION_MAIL = 'mail'
export const COMMERCIAL_DOCS_VERSION_LETTER = 'letter'

export const COMMERCIAL_DOCS_VERSIONS = [
  { value: COMMERCIAL_DOCS_VERSION_MAIL, label: 'Mail', icon: 'fa fa-at' },
  { value: COMMERCIAL_DOCS_VERSION_LETTER, label: 'Lettre', icon: 'fa fa-envelope' }
]

export const COMMERCIAL_DOCS_STATUS_ENABLED = 100
export const COMMERCIAL_DOCS_STATUS_DELETED = 200
export const COMMERCIAL_DOCS_STATUS_INVALID = 300

export const COMMERCIAL_DOCS_STATE_ENABLED_BADGE = {
  value: COMMERCIAL_DOCS_STATUS_ENABLED,
  label: 'Actif',
  color: 'positive'
}
export const COMMERCIAL_DOCS_STATE_DELETED_BADGE = {
  value: COMMERCIAL_DOCS_STATUS_DELETED,
  label: 'Annulé',
  color: 'negative'
}
export const COMMERCIAL_DOCS_STATE_INVALID_BADGE = {
  value: COMMERCIAL_DOCS_STATUS_INVALID,
  label: 'À contrôler',
  color: 'warning'
}

export const COMMERCIAL_DOCS_STATE_BADGES = [
  COMMERCIAL_DOCS_STATE_ENABLED_BADGE,
  COMMERCIAL_DOCS_STATE_DELETED_BADGE,
  COMMERCIAL_DOCS_STATE_INVALID_BADGE
]

export const COMMERCIAL_DOCS_STATE_INDEXED_BADGES = _.keyBy(COMMERCIAL_DOCS_STATE_BADGES, 'value')

export const COMMERCIAL_DOCS_STATE_ENABLED_BADGE_NOT_SENT = {
  label: 'Non envoyé',
  color: 'info'
}
export const COMMERCIAL_DOCS_STATE_ENABLED_BADGE_SENT = {
  label: 'Envoyé',
  color: 'positive'
}

export const COMMERCIAL_DOCS_STATUS_ENABLED_BADGE_VALIDATED = {
  label: 'Validé',
  color: 'positive'
}
export const COMMERCIAL_DOCS_STATUS_ENABLED_BADGE_PENDING = {
  label: 'En attente de validation',
  color: 'warning'
}
export const COMMERCIAL_DOCS_STATUS_ENABLED_BADGE_REFUSED = {
  label: 'Refusé',
  color: 'negative'
}

export const COMMERCIAL_DOCS_STATUS_LIST = [
  {
    value: COMMERCIAL_DOCS_STATUS_ENABLED,
    slug: COMMERCIAL_DOCS_STATUS_ENABLED,
    label: 'Actif',
    color: 'green'
  },
  {
    value: COMMERCIAL_DOCS_STATUS_DELETED,
    slug: COMMERCIAL_DOCS_STATUS_DELETED,
    label: 'Annulé',
    color: 'red'
  },
  {
    value: COMMERCIAL_DOCS_STATUS_INVALID,
    slug: COMMERCIAL_DOCS_STATUS_INVALID,
    label: 'Invalide',
    color: 'red'
  }
]
